import { SignUpArtistTemplate } from '@/components/pages/SignUpArtist/template'
import { Page } from '@/core/architecture'

import { useViewModel } from './viewModel'

/**
 * SignUpArtist Page
 * Implemented as a practical sample.
 */
export const SignUpArtist: Page = () => {
  const { state, actions } = useViewModel()

  return <SignUpArtistTemplate state={state} {...actions} />
}
